import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { isFieldForListingType } from '../../util/fieldHelpers';

import { Heading, ExternalLink } from '../../components';

import css from './ListingPage.module.css';

const SectionLocationsMaybe = props => {
  const { publicData, intl } = props;

  if (!publicData) {
    return null;
  }

  const { firmName, phoneNumber, websiteUrl, location } = publicData;

  let address = location && location.address ? location.address : null;
  if( location && location.building )
    address += ", " + location.building;

  return (
    <section className={css.sectionDetails}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ListingPage.extraLocationsTitle" />
      </Heading>
        { firmName ? (
          <div className={css.locationRow}>
            <span className={css.locationLabel}>
              <FormattedMessage id="ListingPage.extraLocationCompanyNameLabel" />
            </span>
            &nbsp;:&nbsp;
            <span>{firmName}</span>
          </div>
        ) : null }
        { address ? (
          <div className={css.locationRow}>
            <span>{address}</span>
          </div>
        ) : null }
        { phoneNumber ? (
          <div className={css.locationRow}>
            <br/>
            <span className={css.detailLabel}>
              <FormattedMessage id="ListingPage.extraLocationPhoneNumberLabel" />
            </span>
            &nbsp;:&nbsp;
            <span>{phoneNumber}</span>
            <br/><br/>
          </div>
        ) : null }
        { websiteUrl ? (
          <>
            <span className={css.detailLabel}>
              <ExternalLink href={websiteUrl}>
                <FormattedMessage id="ListingPage.extraLocationWebsiteUrlLabel" />
              </ExternalLink>
            </span>
          </>
        ) : null }
    </section>
  );
};

export default SectionLocationsMaybe;
